import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
    providedIn: 'root'
})
export class QuotesService {

    orderHeaderDetails: any;
    updateOrderHeaderDetails = new Subject<number>();
    accountId: number;

    constructor(
        private apiCommonService: ApiCommonService) {
    }

    getOrderHeaderDetails(): Observable<any> {
        return this.updateOrderHeaderDetails.asObservable();
    }

    quote(data: object): Observable<any> {
        return this.apiCommonService.post('Quotes', data);
    }

    updateQuote(data: object): Observable<any> {
        return this.apiCommonService.post('Quotes/Update', data);
    }

    getOrderGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Quotes', event, searchQuery, statusQuery, '');
    }

    exportQuotes(event: any, searchQuery: string, queryString): Observable<object> {
        return this.apiCommonService.export('Quotes/export', event, searchQuery, queryString, '');
    }

    getQuote(id: string): Observable<any> {
        return this.apiCommonService.get(`Quotes/Id?Id=${id}`);
    }

    getDimWeightFactors(): Observable<any> {
        return this.apiCommonService.get(`Quotes/DimWeightFactor/Lookup`);
    }


    getDocumentConfig(id: string, documentTypeId?: any): Observable<any> {
        return this.apiCommonService.get(`Documents/DocumentConfigsByOrderId?OrderId=${id}&DocumentType=${documentTypeId ? documentTypeId : 0}`);
    }

    getJobTypes(): Observable<any> {
        return this.apiCommonService.get(`Quotes/JobTypeLookup?IsJobRelated=true`);
    }

    setAccountID(data: any) {
        this.accountId = data;
    }

    getAccountID(): any {
        return this.accountId;
    }

    gerQuotesStatusWithCount(queryString: string): Observable<any> {
        return this.apiCommonService.get(`Common/StatusWithCount?${queryString}`);
    }
}
